const FilterPropertyType = {
	ENUM: "enum",
	STRING: "string",
	NUMBER: "number",
	// NUMBER_RANGE: "number_range",
	RELATIVE_TIME: "relative_time"
};
export default FilterPropertyType;
